import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Gift, ArrowLeft, Heart } from 'lucide-react';
import { supabase } from '../../lib/supabase';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [registryId, setRegistryId] = useState<string | null>(null);
  const [customMessage, setCustomMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let rid: string | null = null;
    try { rid = sessionStorage.getItem('payhere_registry_id'); } catch {}
    setRegistryId(rid);

    const loadThankYou = async () => {
      if (rid) {
        try {
          const { data } = await supabase
            .rpc('get_registry_thank_you_message', { p_registry_id: rid });
          if (data) setCustomMessage(data);
        } catch {}
      }
      setLoading(false);
    };
    loadThankYou();
  }, []);

  const handleBackToRegistry = () => {
    try { sessionStorage.removeItem('payhere_registry_id'); } catch {}
    if (registryId) {
      navigate(`/registries/${registryId}`);
    } else {
      navigate('/');
    }
  };

  const handleClose = () => {
    try { sessionStorage.removeItem('payhere_registry_id'); } catch {}
    navigate('/');
  };

  const defaultMessage = 'Thank you so much for your generous gift! It truly means the world to us.';

  return (
    <div className="min-h-screen bg-pastel-gradient flex items-center justify-center p-4">
      <div className="card-pastel p-8 sm:p-10 max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="relative">
            <div className="bg-pastel-green-100 p-5 rounded-full">
              <Check className="w-10 h-10 text-pastel-green-600" />
            </div>
            <div className="absolute -top-1 -right-1 bg-white rounded-full p-1.5 shadow-sm">
              <Gift className="w-4 h-4 text-pastel-purple-500" />
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-800 font-poppins">Payment Successful!</h1>
          <p className="text-sm text-gray-500 font-poppins">Your gift has been received</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-4">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-pastel-purple-500" />
          </div>
        ) : (
          <div className="bg-white/60 rounded-xl p-5 border border-white/40">
            <Heart className="w-5 h-5 text-rose-400 mx-auto mb-3" />
            <p className="text-gray-700 font-poppins text-sm leading-relaxed">
              {customMessage || defaultMessage}
            </p>
          </div>
        )}

        <div className="space-y-3 pt-2">
          <button
            onClick={handleBackToRegistry}
            className="w-full flex items-center justify-center gap-2 px-5 py-3 bg-primary text-white rounded-xl hover:bg-primary-600 transition-colors font-medium font-poppins text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Gift Registry
          </button>
          <button
            onClick={handleClose}
            className="w-full px-5 py-3 bg-white/60 text-gray-600 rounded-xl hover:bg-white/80 transition-colors font-poppins text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
